module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "donate"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Donate Now")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('h5', [_vm._v("Donation Type & Amount")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.frequency),
      expression: "frequency"
    }],
    attrs: {
      "type": "radio",
      "value": "oneTime"
    },
    domProps: {
      "checked": _vm._q(_vm.frequency, "oneTime")
    },
    on: {
      "__c": function($event) {
        _vm.frequency = "oneTime"
      }
    }
  }), _vm._v(" One-Time Donation\n        ")]), _vm._v(" "), _c('span', [_vm._v("— or —")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.frequency),
      expression: "frequency"
    }],
    attrs: {
      "type": "radio",
      "value": "sustaining"
    },
    domProps: {
      "checked": _vm._q(_vm.frequency, "sustaining")
    },
    on: {
      "__c": function($event) {
        _vm.frequency = "sustaining"
      }
    }
  }), _vm._v(" Sustaining Donation\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "donations"
  }, [(_vm.frequency === 'oneTime') ? _c('div', [_c('h5', [_vm._v("Each backpack and uniform costs £50. How many backpacks would you like?")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("You also may support school supplies and uniforms for an entire school. Please contact us for details.")]), _vm._v(" "), _c('p', [_vm._v("Here's what you are giving --")]), _vm._v(" "), _c('p', [_vm._v("Each backpack for K-2nd grade contains:")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("Each backpack for 3rd-College contains:")]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.frequency === 'sustaining') ? _c('div', [_c('h5', [_vm._v("Yes, I'd like support Pencils For Kids, Inc. year-round with easy automatic payments, in this amount each month:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', [_vm._v("Pencils For Kids, Inc., will never share our contributors' financial information, phone numbers or emails with anyone. We respect your privacy and will only contact you if necessary regarding your donation.")]), _vm._v(" "), _c('p', [_vm._v("Pencils For Kids, Inc., is a non-profit corporation with 501c3 tax-exempt status.")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("You can make a "), _c('strong', [_vm._v("one-time gift")]), _vm._v(" to Pencils For Kids UK or "), _c('strong', [_vm._v("sign up for a sustaining donation")]), _vm._v(", which supports our missions year-round. All donations are tax-deductible.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate-buttons"
  }, [_c('form', {
    attrs: {
      "action": "https://www.paypal.com/donate",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "NF3F6Q2SDJ4VA"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "value": "1 Backpack - Donate £50",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://www.paypal.com/donate",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "LNMVGWU92PEPL"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "value": "2 Backpacks - Donate £100",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://www.paypal.com/donate",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "6ULVHJPB94RC2"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "value": "3 Backpacks - Donate £150",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://www.paypal.com/donate",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "84ADFWZEP69WW"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "value": "4 Backpacks - Donate £200",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://www.paypal.com/donate",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "89W57MBGG2KF8"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "value": "5 Backpacks - Donate £250",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://www.paypal.com/donate",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "UATRKDDWZ3VEJ"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "value": "8 Backpacks - Donate £400",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://www.paypal.com/donate",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "T6NZ8MRWJ9HYE"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "value": "10 Backpacks - Donate £500",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://www.paypal.com/cgi-bin/webscr",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id",
      "value": "SHCE8DM4D9RLG"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "value": "Donate Other",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "amount",
      "value": "15"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("1 school uniform")]), _vm._v(" "), _c('li', [_vm._v("1 dozen pencils")]), _vm._v(" "), _c('li', [_vm._v("12 notebooks")]), _vm._v(" "), _c('li', [_vm._v("1 box of crayons")]), _vm._v(" "), _c('li', [_vm._v("1 package of markers")]), _vm._v(" "), _c('li', [_vm._v("1 package of colored pencils")]), _vm._v(" "), _c('li', [_vm._v("2 pads of coloring paper")]), _vm._v(" "), _c('li', [_vm._v("1 pencil bag")]), _vm._v(" "), _c('li', [_vm._v("2 erasers")]), _vm._v(" "), _c('li', [_vm._v("1 pencil sharpener")]), _vm._v(" "), _c('li', [_vm._v("1 ruler")]), _vm._v(" "), _c('li', [_vm._v("1 journal")]), _vm._v(" "), _c('li', [_vm._v("1 toothbrush")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("1 school uniform")]), _vm._v(" "), _c('li', [_vm._v("1 dozen pencils")]), _vm._v(" "), _c('li', [_vm._v("12 notebooks")]), _vm._v(" "), _c('li', [_vm._v("1 package of ballpoint pens")]), _vm._v(" "), _c('li', [_vm._v("1 package of markers")]), _vm._v(" "), _c('li', [_vm._v("1 package of colored pencils")]), _vm._v(" "), _c('li', [_vm._v("2 pads of coloring paper")]), _vm._v(" "), _c('li', [_vm._v("1 pencil bag")]), _vm._v(" "), _c('li', [_vm._v("2 erasers")]), _vm._v(" "), _c('li', [_vm._v("1 pencil sharpener")]), _vm._v(" "), _c('li', [_vm._v("1 ruler")]), _vm._v(" "), _c('li', [_vm._v("1 journal")]), _vm._v(" "), _c('li', [_vm._v("1 toothbrush")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": "https://www.paypal.com/cgi-bin/webscr",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_xclick-subscriptions"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "business",
      "value": "7MP7BPZLRAR2W"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lc",
      "value": "US"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "item_name",
      "value": "Sustaining Donation"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_note",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_shipping",
      "value": "2"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "src",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "srt",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "p3",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "t3",
      "value": "M"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "a3",
      "value": "10"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency_code",
      "value": "GBP"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "bn",
      "value": "PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "submit",
      "value": "£10",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": "https://www.paypal.com/cgi-bin/webscr",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_xclick-subscriptions"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "business",
      "value": "7MP7BPZLRAR2W"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lc",
      "value": "US"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "item_name",
      "value": "Sustaining Donation"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_note",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_shipping",
      "value": "2"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "src",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "srt",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "p3",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "t3",
      "value": "M"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "a3",
      "value": "15"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency_code",
      "value": "GBP"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "bn",
      "value": "PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "submit",
      "value": "£15",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": "https://www.paypal.com/cgi-bin/webscr",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_xclick-subscriptions"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "business",
      "value": "7MP7BPZLRAR2W"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lc",
      "value": "US"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "item_name",
      "value": "Sustaining Donation"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_note",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_shipping",
      "value": "2"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "src",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "srt",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "p3",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "t3",
      "value": "M"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "a3",
      "value": "20"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency_code",
      "value": "GBP"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "bn",
      "value": "PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "submit",
      "value": "£20",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": "https://www.paypal.com/cgi-bin/webscr",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_xclick-subscriptions"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "business",
      "value": "7MP7BPZLRAR2W"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lc",
      "value": "US"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "item_name",
      "value": "Sustaining Donation"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_note",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_shipping",
      "value": "2"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "src",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "srt",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "p3",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "t3",
      "value": "M"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "a3",
      "value": "25"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency_code",
      "value": "GBP"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "bn",
      "value": "PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "submit",
      "value": "£25",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": "https://www.paypal.com/cgi-bin/webscr",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_xclick-subscriptions"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "business",
      "value": "7MP7BPZLRAR2W"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lc",
      "value": "US"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "item_name",
      "value": "Sustaining Donation"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_note",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_shipping",
      "value": "2"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "src",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "srt",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "p3",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "t3",
      "value": "M"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "a3",
      "value": "30"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency_code",
      "value": "GBP"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "bn",
      "value": "PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "submit",
      "value": "£30",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": "https://www.paypal.com/cgi-bin/webscr",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_xclick-subscriptions"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "business",
      "value": "7MP7BPZLRAR2W"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lc",
      "value": "US"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "item_name",
      "value": "Sustaining Donation"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_note",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_shipping",
      "value": "2"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "src",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "srt",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "p3",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "t3",
      "value": "M"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("£")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "a3",
      "value": "5",
      "required": "",
      "step": "any",
      "size": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("/ mo")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency_code",
      "value": "GBP"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "bn",
      "value": "PP-SubscriptionsBF:btn_subscribeCC_LG.gif:NonHosted"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "submit",
      "value": "Donate Other",
      "name": "submit",
      "alt": "PayPal - The safer, easier way to pay online!"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/en_US/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6cfb9952!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Donate.vue
// module id = 401
// module chunks = 2